const home = {
  heroAlt: "专业人员在装修现场查看图纸",
  galleryAlt: "建筑与装修行业",
  install: {
    iosSub: "下载于",
    androidSub: "下载于",
    iosTitle: "在 iPhone/iPad 上安装",
    iosDesc: "在 Safari 中打开此页面，点按“分享”，然后选择“添加到主屏幕”。",
    androidTitle: "安装应用",
    androidDesc: "打开浏览器菜单，选择“安装应用”或“添加到主屏幕”。",
  },
  apps: {
    nuvliTitle: "NuvliPro 手机应用",
    nuvliDesc: "在手机上管理报价、发票、工程、支出和工时。",
    nuvliInstall: "下载 NuvliPro",
    nuvliNote: "直接安装（PWA）· 支持 Android 和 iPhone，不占用存储空间。",
    workerTitle: "GPS 打卡手机应用",
    workerDesc: "适用于员工：通过 GPS 上下班打卡，并使用访问码登录。",
    workerInstall: "下载 GPS 打卡",
    workerNote: "适用于工人 · 安装后打开应用，使用您的访问码登录。",
    workerCta: "打开员工应用",
    qrTitle: "GPS 考勤管理",
    qrSubtitle: "为您的团队提供简单安全的打卡",
    qrText: "从我们的网站免费下载",
    qrInstall: "安装到手机",
    qrAvailable: "支持 Android 和 iPhone",
  },
  login: {
    title: "登录", email: "电子邮箱", password: "密码", emailPh: "you@email.com", submit: "登录",
    forgot: "忘记密码？", register: "免费注册", welcome: "欢迎", error: "登录失败",
  },
  features: {
    badge: "功能",
    title: "管理业务所需的一切",
    items: [
      { t: "开票", d: "自动编号的发票，含增值税和预扣税、状态管理及专业 PDF 下载。" },
      { t: "报价", d: "按章节和详细条目编制报价；一键转换为发票。" },
      { t: "支出管理", d: "记录材料、人工和供应；按工程和类别控制支出。" },
      { t: "分期收款", d: "记录预付款，跟踪未结余额，并自动发送收据。" },
      { t: "季度报告", d: "按季度汇总增值税和所得税，可直接交给会计，并可导出为 PDF 和 Excel。" },
      { t: "客户管理", d: "每位客户的完整档案、文档历史记录及逾期付款识别。" },
    ],
  },
  pricing: {
    badge: "套餐与价格",
    title: "选择最适合您业务的套餐",
    subtitle: "免费开始，无使用期限。需要更多功能时随时升级：无需长期绑定，可随时取消。",
    freeCta: "免费创建账户",
    labels: { gratuito: "免费套餐", trimestral: "季度套餐", anual: "年度套餐" },
    perMonth: "{{amount}}/月",
    approx: "≈ {{amount}}/月",
    periodo: { gratuito: "无使用期限", trimestral: "每 3 个月 {{total}}", anual: "每年 {{total}}" },
    nota: { gratuito: "无需付费即可开始", trimestral: "无限制，每 3 个月付款", anual: "每年仅需付款一次" },
    badges: { trimestral: "最受欢迎" },
    save: "每年节省 {{amount}}",
    features: {
      gratuito: ["最多 8 个客户", "最多 8 份报价", "为您的 8 个客户开票与分期收款", "支出与季度管理：最近 2 个季度", "2 个工程项目", "考勤打卡，员工人数不限"],
      trimestral: ["客户、报价和工程不限数量", "完整的支出与季度历史", "AI、VeriFactu 与银行对账", "邮件和 WhatsApp 提醒", "为会计导出数据"],
      anual: ["包含季度套餐全部功能", "自定义文档和标志", "定时自动提醒", "优先支持"],
    },
    payCard: "银行卡支付",
    payNote: "银行卡：自动续订，可随时取消",
    footnote: "价格不含增值税 · 银行卡支付 · 由 Stripe 提供安全支付",
    approxNote: "按今日汇率折算的 {{currency}} 近似金额。确切金额以支付页面显示为准。",
    payError: "无法发起支付",
  },
  trust: {
    title: "已信赖 NuvliPro 的专业人士",
    subtitle: "来自建筑与装修行业企业的真实评价。",
    testimonials: [
      { cargo: "总经理", empresa: "Constructora MendozaBuild S.A.", texto: "十多年来，我们一直使用 Excel 和互不相通的系统。有了 NuvliPro，我们整合了 8 个项目的全部信息，行政管理时间减少了 60%。现在每个项目的盈利报告都很准确，我依据真实数据而不是直觉做决策。" },
      { cargo: "项目总监", empresa: "Grupo Constructor Rojas & Asociados", texto: "我们的在建项目从 3 个增加到 12 个，原来的手工系统彻底崩溃。借助 NuvliPro，我们在不增加一倍行政人员的情况下实现了增长：每种材料全程可追溯、实时管理分包商，最终文档减少了 75%。客户收到的报告让他们更加信任我们。" },
      { cargo: "个体经营者", empresa: "从业 18 年", texto: "我的工程越来越复杂、利润越来越低，成本不知不觉地流失。使用 NuvliPro 后，我找到了资金漏洞，整合了供应商，在不牺牲质量的前提下将管理费用降低了 22%。现在我能用更少的时间做出更详细的报价，拿下更多项目。" },
    ],
    seals: [
      { t: "符合 GDPR", d: "数据受保护" },
      { t: "SSL 加密", d: "安全连接" },
      { t: "Stripe 支付", d: "收款有保障" },
      { t: "西班牙语支持", d: "随时为您服务" },
    ],
  },
  demo: {
    badge: "演示视频",
    title: "2 分钟了解 NuvliPro",
    subtitle: "看看如何创建报价、将其转换为发票，并管理收款和支出。",
    unsupported: "您的浏览器不支持视频播放。",
    soon: "演示视频即将推出",
  },
  faq: {
    badge: "常见问题",
    title: "为您解答疑问",
    items: [
      { q: "使用 NuvliPro 需要会计知识吗？", a: "不需要。NuvliPro 专为个体经营者和小型企业设计：只需填写清晰的字段即可创建报价和发票，应用会自动计算增值税、预扣税和总额。" },
      { q: "可以免费试用吗？", a: "可以。免费套餐没有使用期限，也无需绑定银行卡：最多 8 个客户、8 份报价、8 张发票和 1 个进行中的工程项目。需要更多时，可升级到付费套餐。" },
      { q: "我的客户数据安全吗？", a: "安全。我们对连接进行加密（SSL），遵守 GDPR，付款通过 Stripe 安全处理。我们绝不会共享您的数据。" },
      { q: "可以用我的标志定制发票和报价吗？", a: "可以。在个人中心中，您可以上传公司标志，并选择符合您品牌形象的文档设计。" },
      { q: "NuvliPro 能用于季度税务管理吗？", a: "能。它会自动生成每个季度的销项/进项增值税和所得税汇总，可导出为 PDF 和 Excel 交给您的会计。" },
      { q: "可以随时取消吗？", a: "当然可以。无需长期绑定：您可以随时在账户中更改或取消套餐。" },
    ],
  },
  contact: {
    badge: "联系我们",
    title: "聊一聊？",
    subtitle: "告诉我们您的需求，我们会尽快回复。我们随时帮助您充分利用 NuvliPro。",
    support: "客户服务",
    supportNote: "西班牙语支持 · 24-48 小时内回复",
    name: "姓名", namePh: "您的姓名", email: "电子邮箱", emailPh: "you@email.com",
    message: "留言", messagePh: "我们能为您做些什么？", send: "发送留言",
    sent: "留言已发送！我们会尽快回复您。", error: "留言发送失败",
  },
  cta: {
    title: "您的全部业务，尽在一处",
    items: ["客户", "报价", "开票", "分期收款", "支出", "季度", "逾期付款", "WhatsApp"],
    button: "免费创建我的账户",
  },
  footer: "面向建筑与装修专业人士的一站式管理",
};
export default home;
